// extracted by mini-css-extract-plugin
export default {"srOnly":"_pfxlW","rotated":"RG3k61"};